import React from 'react';

import { ContractHistory } from '~/screens/Person/components/Modals/ContractHistory/ContractHistory';

import { ContractSubViewHeader } from '../components/ContractSubViewHeader';

type ContractHistoryViewProps = {
  contractId: string;
  contractDetails: any;
  onBack: () => void;
};

export function ContractHistoryView({ contractId, contractDetails, onBack }: ContractHistoryViewProps) {
  return (
    <div>
      <ContractSubViewHeader contractId={contractId} onBack={onBack} />
      <ContractHistory
        id={contractId}
        product={contractDetails?.loanType}
        externalId={contractDetails?.externalId}
        fitParent
      />
    </div>
  );
}
